import type { AssistConfiguratorSettings } from './CustomizeForms/types';

export const ASSIST_DEFAULT_VALUES: Omit<AssistConfiguratorSettings, 'extras'> =
  {
    position: {
      topPosition: { value: '15%', error: false },
      rightPosition: { value: '10px', error: false },
      mobileBottomPosition: { value: '15%', error: false },
      mobileRightPosition: { value: '10px', error: false },
      sidePosition: { value: 'right', error: false },
      mobileSidePosition: { value: 'right', error: false },
    },
    appearance: {
      iconSize: { value: '70px', error: false },
      mobileIconSize: { value: '50px', error: false },
      customIconColor: { value: '#000000', error: false },
      customBackgroundColor: { value: '#000000', error: false },
      externalLogoUrl: { value: '', error: false },
    },
    advanced: {
      maxMagnification: { value: 15, error: false },
      maxMobileMagnification: { value: 3, error: false },
      blacklistContrast: { value: '', error: false },
      blacklistDarkmode: { value: '', error: false },
      blacklistFontsize: { value: '', error: false },
      forceWhiteBackground: { value: '', error: false },
      userLang: { value: 'auto', error: false },
      disableAllShortcuts: { value: false, error: false },
      hideIcon: { value: false, error: false },
      shareLocalStorage: { value: false, error: false },
      forceInlineColor: { value: false, error: false },
    },
    funcPosition: {
      Bluefilter: { value: 'Main', error: false },
      Darkmode: { value: 'Main', error: false },
      TabNavi: { value: 'More', error: false },
      ColorCorrection: { value: 'Main', error: false },
      HideImages: { value: 'Main', error: false },
      LargeCursor: { value: 'More', error: false },
      StopAnimation: { value: 'More', error: false },
    },
    readAloud: {
      sRStartElement: { value: '', error: false },
      sRTextBlock: { value: '', error: false },
      blacklistScreenReader: { value: '', error: false },
      srDictionary: { value: {}, error: false },
      srPhoentic: { value: {}, error: false },
    },
  };

export const WEBSITE_LANGUAGES = [
  { value: 'af', label: 'Afrikaans (af)' },
  { value: 'ar', label: '(اللغة) العربي (ar)' },
  { value: 'id', label: 'Bahasa Indonesia (id)' },
  { value: 'ms', label: 'Bahasa Melayu (ms)' },
  { value: 'cs', label: 'čeština (cs)' },
  { value: 'zh', label: '中文 (zh)' },
  { value: 'da', label: 'Dansk (da)' },
  { value: 'de', label: 'Deutsch (de)' },
  { value: 'et', label: 'Eesti keel (et)' },
  { value: 'en', label: 'English (en)' },
  { value: 'el', label: 'Ελληνικά (el)' },
  { value: 'es', label: 'Español (es)' },
  { value: 'fr', label: 'Français (fr)' },
  { value: 'hr', label: 'Hrvatski (hr)' },
  { value: 'hi', label: 'हिन्दी (hi)' },
  { value: 'xh', label: 'isiXhosa (xh)' },
  { value: 'zu', label: 'isiZulu (zu)' },
  { value: 'it', label: 'Italiano (it)' },
  { value: 'ja', label: '日本語 (ja)' },
  { value: 'ko', label: '한국의 (ko)' },
  { value: 'lv', label: 'Latviski (lv)' },
  { value: 'lt', label: 'Lietuvių (lt)' },
  { value: 'no', label: 'Norsk (no)' },
  { value: 'nl', label: 'Nederlands (nl)' },
  { value: 'uk', label: 'український (uk)' },
  { value: 'ro', label: 'Română (ro)' },
  { value: 'pl', label: 'Polski (pl)' },
  { value: 'pt', label: 'Português (pt)' },
  { value: 'ru', label: 'Pу́сский (ru)' },
  { value: 'fil', label: 'Wikang Filipino (fil)' },
  { value: 'sr', label: 'Српски (sr)' },
  { value: 'sk', label: 'Slovenský (sk)' },
  { value: 'sl', label: 'Slovenščina (sl)' },
  { value: 'st', label: 'Sesotho (st)' },
  { value: 'fi', label: 'Suomi (fi)' },
  { value: 'sv', label: 'Svenska (sv)' },
  { value: 'tr', label: 'Türkçe (tr)' },
  { value: 'ts', label: 'Xitsonga (ts)' },
];
